import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { SesiuneCadou } from './pages/SesiuneCadou';
import { Testimoniale } from './pages/Testimoniale';
import { Contact } from './pages/Contact';
import { Despre } from './pages/Despre';
import { Workshop } from './pages/Workshop';
import { OfertaRise } from './pages/OfertaRise';
import { ProgramulRise } from './pages/ProgramulRise';
import { ComunitateRise } from './pages/ComunitateRise';
import { Coaching1la1 } from './pages/Coaching1la1';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-rise-black text-rise-white selection:bg-rise-gold/30" data-id="element-2">
        <Navbar data-id="element-3" />
        <Routes data-id="element-4">
          <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
          <Route path="/acasa" element={<Home data-id="element-8" />} data-id="element-7" />
          <Route path="/sesiune1la1" element={<SesiuneCadou data-id="element-10" />} data-id="element-9" />
          <Route path="/testimoniale" element={<Testimoniale data-id="element-12" />} data-id="element-11" />
          <Route path="/contact" element={<Contact data-id="element-14" />} data-id="element-13" />
          <Route path="/despremine" element={<Despre data-id="element-16" />} data-id="element-15" />
          <Route path="/workshop" element={<Workshop data-id="element-18" />} data-id="element-17" />
          <Route path="/ofertarise" element={<OfertaRise data-id="element-20" />} data-id="element-19" />
          <Route path="/oferterise" element={<OfertaRise data-id="element-22" />} data-id="element-21" />
          <Route path="/programulrise" element={<ProgramulRise data-id="element-24" />} data-id="element-23" />
          <Route path="/comunitaterise" element={<ComunitateRise data-id="element-26" />} data-id="element-25" />
          <Route path="/coaching1la1" element={<Coaching1la1 data-id="element-28" />} data-id="element-27" />
        </Routes>
        <Footer data-id="element-29" />
      </div>
    </BrowserRouter>;
}